import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController, LoadingController } from 'ionic-angular';
import { login, SharedService, Country,register, RegisterService  } from 'baseline-lib';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CustomToast } from '../services/custom-toast';

/**
 * Generated class for the ForgotPasswordModalPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-forgot-password-modal',
  templateUrl: 'forgot-password-modal.html',
})
export class ForgotPasswordModalPage {

  sendOtpClicked : boolean = false;
  enterOTP : number;
  mobileNumber : number;
  password ;
  public registerDetails: register;
  public countryList: Country[];
  countryId : number

  constructor(public navCtrl: NavController, public navParams: NavParams,
    public translate : TranslateService, public toast : CustomToast,
    public viewCtrl : ViewController, public _sharedServices : SharedService, public _registerServices : RegisterService, public loadingCtrl : LoadingController) {

      this.registerDetails = new register();
      this.countryId = null;
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ForgotPasswordModalPage');
  }

  ngOnInit()
  {
    this.registerDetails.vendorId = this._sharedServices._configService.getVendorId();
    this._registerServices.countryListDetails(this.registerDetails).subscribe(data => {
      this.countryList = [];
      if (data.data) {
        data.data.forEach(element => {
          var _country = new Country();
          _country.countryData(element);
          this.countryList.push(_country);
        });
      }
    });
  }

  goBack() {
    this.viewCtrl.dismiss();
  }

  sendOtp(){

    const loader = this.loadingCtrl.create({
      content: "Please Wait",
    });

    if(!this.countryId)
    {
      this.translate.get('Country is required').subscribe(
        value => 
        {
          this.toast.showError(value);
        });
    }
    else if(!this.mobileNumber) {
      this.translate.get('Username is required').subscribe(
        value => 
        {
          this.toast.showError(value);
        });

      //return false;
    }else {
     
      this.registerDetails.countryId = this.countryId;
      this.registerDetails.mobileNumber = this.mobileNumber;

      this._registerServices.forgetPasswordDetails(this.registerDetails).subscribe(
        data => {
          loader.dismiss()
          console.log(data);
          if (data.errorCode == 0 || data.errorCode == undefined || data.errorCode == null) {
            //this._notify.successMsg = data.message;
            this.toast.showSuccess(data.message);
            this.sendOtpClicked = true;
          }
          else {
            this.toast.showError(data.message);
          }
        }, error => {
          loader.dismiss()
          if (error.msg) {
            this.toast.showError(error.msg);
          }
          else {
            this.toast.showError(error.message);
          }
        });
    }
    
  }

  updatePswd()
  {

    const loader = this.loadingCtrl.create({
      content: "Please Wait",
    });

    var passwordPattern = new RegExp(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{8,}$/);;
    var checkPassword = passwordPattern.test(this.password)
    if(!this.enterOTP)
    {
      this.translate.get('OTP Cannot Be Empty').subscribe(
        value => 
        {
          this.toast.showError(value);
        });
      return false;
    }
    else if(!checkPassword)
    {
      this.translate.get('Please enter more than 8 char password (Including 1 special char, 1 capital letter, 1 small letter, 1 Number)').subscribe(
        value => 
        {
          this.toast.showError(value);
        });
      return false;
    }
    else
    {
      this.registerDetails.otp = this.enterOTP;
      this.registerDetails.password = this.password;

      this._registerServices.updatePasswordDetails(this.registerDetails).subscribe(
        data => {
          loader.dismiss()
          console.log(data);
          if (data.errorCode == 0 || data.errorCode == undefined || data.errorCode == null) {
            //this._notify.successMsg = data.message;
            this.toast.showSuccess(data.message);
            this.goBack()
          }
          else {
            this.toast.showError(data.message);
          }
        }, error => {
          loader.dismiss()
          if (error.msg) {
            this.toast.showError(error.msg);
          }
          else {
            this.toast.showError(error.message);
          }
        });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/forgot-password-modal/forgot-password-modal.ts